<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>Lazer, Cultura e Esporte</b></h5>
        </th>
      </tr>

      <tr>
        <td>
          PARTICIPA DE ALGUMA ATIVIDADE CULTURAL?
          <b>{{ usuario.participa_atividade_cultural || '-' }}</b>
        </td>
        <td>
          QUAL ATIVIDADE CULTURAL PARTICIPA?
          <b>{{ usuario.qual_atividade_participa || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td>
          GOSTARIA DE PARTICIPAR DE ALGUMA ATIVIDADE CULTURAL?
          <b>{{ usuario.gostaria_participar_atividade || '-' }}</b>
        </td>
        <td>
          QUAL ATIVIDADE CULTURAL GOSTARIA DE PARTICIPAR?
          <b>{{ usuario.qual_atividade_gostaria_participar || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td>
          PARTICIPA DE ALGUMA ATIVIDADE DESPORTIVA?
          <b>{{ usuario.participa_atividade_desportiva || '-' }}</b>
        </td>
        <td>
          QUAL ATIVIDADE DESPORTIVA PARTICIPA?
          <b>{{ usuario.qual_atividade_desportiva_participa || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td>
          GOSTARIA DE PARTICIPAR DE ALGUMA ATIVIDADE DESPORTIVA?
          <b>{{ usuario.gostaria_participar_atividade_desportiva || '-' }}</b>
        </td>
        <td>
          QUAL ATIVIDADE DESPORTIVA GOSTARIA DE PARTICIPAR?
          <b>{{ usuario.qual_atividade_desportiva_gostaria_participar || '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          OBSERVAÇÃO SOBRE HORAS LIVRES (LAZER)
          <span v-html="usuario.observacoes || '-'"></span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["usuario"],
};
</script>